import { useSubscription } from "@apollo/client";
import { SEAT_UPDATED_SUBSCRIPTION } from "./service";
import { useDispatch, useSelector } from "react-redux";
import { setFloorJson } from "../redux/Actions/FloorAction";

export function SeatSubscription({ id }) {

    const FloorReducer = useSelector((state) => state.FloorReducer);
    const dispatch = useDispatch();
    console.log('FloorReducer--', FloorReducer);
    useSubscription(SEAT_UPDATED_SUBSCRIPTION, {
        variables: { id },
        onSubscriptionData: ({ subscriptionData }) => {

            console.log('subscriptionData---', subscriptionData);


            if (FloorReducer.doc !== null && FloorReducer?.doc?.length !== 0) {
                const updatedSeat = subscriptionData.data?.seatUpdated;
                if (!updatedSeat) return;

                const index = FloorReducer.doc.findIndex((item) => item._id === id);
                if (index === -1) return;
                const updatedFloor = { ...FloorReducer }; // shallow copy
                updatedFloor.doc = [...FloorReducer.doc]; // copy array
                updatedFloor.doc[index] = {
                    clientInfo: updatedSeat.clientInfo,
                    deviceInfo: updatedSeat.deviceInfo,
                    seatCode: updatedSeat.seatCode,
                    seatFor: updatedSeat.seatFor,
                    seatName: updatedSeat.seatName,
                    unitIds: updatedSeat.unitIds,
                    staffIds: updatedSeat.staffIds,
                    serviceInfo: updatedSeat.serviceInfo,
                    status: updatedSeat.status,
                    _id: updatedSeat._id?updatedSeat._id:updatedSeat.id,
                };
                dispatch(setFloorJson(updatedFloor.doc));
            }
        },
    });

    return null; // no UI, just subscription
}